<common-ui-components-page-layout title="قوانین و مقررات">
  <div class="p-plus">
    <img
      src="assets/rules.png"
      alt="digipay rules"
      class="rules-image"
    />
    <div
      class="mt-big fs-14"
      [innerHTML]="content()"
    ></div>
  </div>
</common-ui-components-page-layout>
